import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initAnalytics, trackEvent } from "@/lib/analytics";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Problem } from "@/components/Problem";
import { Process } from "@/components/Process";
import { Outcomes } from "@/components/Outcomes";
import { Capabilities } from "@/components/Capabilities";
import { ProductFamilies } from "@/components/ProductFamilies";
import { Differentiation } from "@/components/Differentiation";
import { Pricing } from "@/components/Pricing";
import { EnquiryForm } from "@/components/EnquiryForm";
import { Trust } from "@/components/Trust";
import { CustomSolution } from "@/components/CustomSolution";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const Landing = () => {
    useEffect(() => {
        trackEvent("page_view", { page_path: "/" });
    }, []);

    return (
        <>
            <Nav />
            <main>
                <Hero />
                <Problem />
                <Process />
                <Outcomes />
                <Capabilities />
                <ProductFamilies />
                <Differentiation />
                <Pricing />
                <EnquiryForm />
                <Trust />
                <CustomSolution />
                <FinalCTA />
            </main>
            <Footer />
        </>
    );
};

function App() {
    useEffect(() => {
        initAnalytics();
    }, []);

    return (
        <div className="App" data-testid="flowpilot-site">
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
